import { Outlet } from '@tanstack/react-router';
import { Sidebar } from './Sidebar';

/**
 * Authenticated shell — Sidebar (fixed) + scrollable main area.
 * Page-level TopBanner is mounted per-route so each page controls
 * its title, search placeholder, etc.
 */
export function Layout() {
  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar />
      <main className="flex flex-1 flex-col overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}
